import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGitlabAvailable } from '@veecode-platform/backstage-plugin-gitlab-pipelines';

export const gitlabPipelinesTab = EntityContentBlueprint.make({
  name: 'ci-cd',
  params: {
    path: 'ci-cd',
    title: 'CI/CD',
    filter: isGitlabAvailable,
    loader: () =>
      import('./GitlabPipelinesContent').then(m => (
        <m.GitlabPipelinesContent />
      )),
  },
});
